import Join from "../pages/Join";
import PasswordFinder from "../pages/PasswordFinder";

const protectedPages = [
];

const publicPages = [
  // { path: "/passwordReset", element: <PasswordReset />,},
  { path: "/join", element: <Join />,},
  { path: "/password_find", element: <PasswordFinder/>}
];

const pageConfig = { protectedPages, publicPages };


export default pageConfig;